// extracted by mini-css-extract-plugin
export default {"counter":"MyCounter_counter__uojf1","counter__btn":"MyCounter_counter__btn__D3HX1","counter__count":"MyCounter_counter__count__cj+sU"};